module.exports = __webpack_public_path__ + "static/media/loader.e7d1690f.svg";